



























































import { Component, Mixins, Prop } from "vue-property-decorator";
import { ReceptionApplicant } from "../../../../domain/workflow/reception";
import { WorkflowCommonMixin } from "../../mixins";

@Component({
  components: {}
})
export default class ReceptionApplicantView extends Mixins(WorkflowCommonMixin) {
  @Prop()
  applicant: ReceptionApplicant;

  @Prop()
  isAddressTypeEnable: boolean;

  get name(): string {
    return this.applicant ? this.applicant.name : "";
  }

  get relationship(): string {
    return this.applicant ? this.applicant.relationship : "";
  }

  get phoneNumber(): string {
    return this.applicant ? this.applicant.phoneNumber : "";
  }

  get zipCode(): string {
    return this.applicant ? this.applicant.zipCode : "";
  }

  get address(): string {
    return this.applicant ? this.applicant.address : "";
  }

  get cellPhone(): string {
    return this.applicant ? this.applicant.cellPhone : "";
  }

  get email(): string {
    return this.applicant ? this.applicant.email : "";
  }

  get isPatientAddress(): boolean {
    return (this.applicant && this.applicant.isPatientAddress !== null && this.applicant.isPatientAddress !== undefined)
      ? this.applicant.isPatientAddress
      : undefined;
  }

  get addressTypeText(): string {
    if (this.isPatientAddress === undefined) { return ""; }
    return this.isPatientAddress
      ? "患者住所"
      : "その他住所";
  }
}
